import { render, staticRenderFns } from "./peisongset.vue?vue&type=template&id=56d005f0&scoped=true"
import script from "./peisongset.vue?vue&type=script&lang=js"
export * from "./peisongset.vue?vue&type=script&lang=js"
import style0 from "./peisongset.vue?vue&type=style&index=0&id=56d005f0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "56d005f0",
  null
  
)

export default component.exports